import React from 'react'

const Title = ({ text }) => {
  return <h1 className='text-2xl font-bold pt-10 pb-5 select-none'>{text}</h1>
}

export default Title
